import { render, staticRenderFns } from "./ConnectionStatusIcon.vue?vue&type=template&id=45b455b0"
import script from "./ConnectionStatusIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConnectionStatusIcon.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports